module.exports = __webpack_public_path__ + "img/sample-hrRecruiter.0421a67c.webp";